import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

export const Bag = () => {
  const {
    state: { theme },
  } = useGlobalContext();
  const isDarkMode = theme.value === "dark";

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00392 0.75C11.075 0.75 12.7539 2.42893 12.7539 4.5V6H15.0039C15.4181 6 15.7539 6.33579 15.7539 6.75V15.75C15.7539 16.1642 15.4181 16.5 15.0039 16.5H3.00391C2.5897 16.5 2.25391 16.1642 2.25391 15.75V6.75C2.25391 6.33579 2.5897 6 3.00391 6H5.25391V4.5C5.25391 2.42893 6.93284 0.75 9.00392 0.75ZM12.7539 8.25H11.2539V9C11.2539 9.41423 11.5897 9.75 12.0039 9.75C12.3885 9.75 12.7055 9.4605 12.7489 9.08745L12.7539 9V8.25ZM6.75391 8.25H5.25391V9C5.25391 9.41423 5.5897 9.75 6.00391 9.75C6.38854 9.75 6.70554 9.4605 6.74886 9.08745L6.75391 9V8.25ZM9.00392 2.25C7.80565 2.25 6.82616 3.18669 6.75773 4.36779L6.75391 4.5V6H11.2539V4.5C11.2539 3.30174 10.3172 2.32225 9.13615 2.25382L9.00392 2.25Z"
        fill={isDarkMode ? "#F2F2F2" : "#050505bf"}
      />
    </svg>
  );
};
